// removed by extract-text-webpack-plugin
module.exports = {"navegate-menu":"magazines_1OP_O","montserrat":"magazines_2LLMH","navegate-menu__vertical-line":"magazines_2Xr1l","wrapper-page-actions":"magazines_1EE_O","wrapper-page-actions__button":"magazines_bnsfL","wrapper-page-actions__button-close":"magazines_2oqEJ","wrapper-page-actions__nav":"magazines_1hgq_","wrapper-page-actions__nav-active":"magazines_354-w","wrapper-page-actions__nav-palette":"magazines_1qkd_","wrapper-page-actions__toggle":"magazines_2qSCw"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/PageActions/styles.scss
// module id = 1257
// module chunks = 1